

























import { Component, Mixins, Prop } from "vue-property-decorator";

// Mixins
import ClientMixin from "@/mixins/clientMixin";
import Context from "@/mixins/context";

// Types
import { ITicket } from "@/models/tickets";

@Component
export default class TicketParticipantsAvatars extends Mixins(
  Context,
  ClientMixin
) {
  // Props

  @Prop({ required: true })
  public ticket!: ITicket;

  @Prop({ default: 40 })
  public size!: number;

  @Prop({ default: true })
  public includeUsers!: boolean;

  @Prop({ default: true })
  public includeDelegates!: boolean;

  @Prop({ default: true })
  public includeClient!: boolean;

  @Prop({ default: true })
  public includeLead!: boolean;

  // Data

  public fields = ["id", "fullname", "image_url", "email"];

  // Computed

  public get hasClient() {
    return !!this.ticket.client_id;
  }

  public get hasLead() {
    return !!this.ticket.lead_id;
  }

  public get participants() {
    const _ = this.$_;
    const participants = _.orderBy(
      this.ticket.users,
      ["pivot.default"],
      ["desc"]
    );

    // Staff users
    const users = _.map([...participants].reverse(), user => ({
      ..._.pick(user, this.fields),
      label: `${this.isAdmin ? user.fullname : user.public_name} (${this.$t(
        "_.staff"
      )})`
    }));

    // Delegates
    const delegates = _.map(
      _.filter(this.ticket.delegates, delegate => !!delegate.client_id),
      delegate => ({
        ..._.pick(delegate.client, this.fields),
        label: `${delegate.client?.fullname} (${this.$t("_.delegate")})`
      })
    );

    // Client
    const client = {
      ..._.pick(_.get(this.ticket, "client", {}), this.fields),
      label: this.getClientName({
        client: this.ticket.client,
        clientId: this.ticket.client_id,
        orEmail: true
      })
    };

    // Lead
    const lead = {
      id: _.get(this.ticket, "lead.id"),
      fullname: _.get(this.ticket, "lead.name"),
      email: _.get(this.ticket, "lead.email"),
      label: _.get(this.ticket, "lead.name")
    };

    if (!this.isAdmin) {
      return _.filter(users, ["id", _.get(this.ticket, "lead_user.id")]);
    }

    return _.compact([
      ...(this.includeUsers ? users : []),
      ...(this.includeDelegates ? delegates : []),
      ...(this.includeClient && this.hasClient ? [client] : []),
      ...(this.includeLead && this.hasLead ? [lead] : [])
    ]);
  }
}
